import onReady from "./modules/onReady.min.js";
import slugify from "./modules/slugify.min.js";

onReady(() => {
  Tabulator.extendModule("download", "downloaders", {
    string: function (columns, data, options) {
      var fileContents = data.toString();
      return (
        "data:application/txt;charset=utf-8," + encodeURIComponent(fileContents)
      );
    },
  });

  const form = document.getElementById("get-leads-form");
  const viewLeadsBtn = document.getElementById("view-results-btn");
  const resultsWrapper = document.getElementById("results-wrapper");
  const loaderTable = document.getElementById("loader-table");
  const shareLeadsBtn = document.getElementById("share-leads");
  const shareLeadsModal = new bootstrap.Modal(document.getElementById("shareLeadsModal"));
  const shareableUrlInput = document.getElementById("shareableUrl");
  const copyUrlBtn = document.getElementById("copyUrlBtn");

  // Function to handle URL parameters
  const handleUrlParams = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get("search");
    const fieldsParam = urlParams.getAll("fields");
    
    if (searchParam) {
      const postUrlInput = document.getElementById("post-url-input");
      postUrlInput.value = searchParam;
      
      // Restore selected fields from URL parameters
      if (fieldsParam.length > 0) {
        // First, uncheck all fields
        document.querySelectorAll('input[name="fields[]"]').forEach(cb => {
          cb.checked = false;
        });
        
        // Then, check the fields from URL parameters
        fieldsParam.forEach(fieldName => {
          const checkbox = document.getElementById(`field-${fieldName}`);
          if (checkbox) {
            checkbox.checked = true;
          }
        });
      }
      
      form.dispatchEvent(new Event("submit"));
    }
  };

  // Handle copy URL button click
  copyUrlBtn.addEventListener("click", () => {
    shareableUrlInput.select();
    document.execCommand("copy");
    copyUrlBtn.textContent = "Copied!";
    setTimeout(() => {
      copyUrlBtn.textContent = "Copy";
    }, 2000);
  });

  // Handle share leads button click
  shareLeadsBtn.addEventListener("click", () => {
    const postUrlInput = document.getElementById("post-url-input");
    const selectedFields = Array.from(document.querySelectorAll('input[name="fields[]"]:checked')).map(cb => cb.value);
    const urlParams = new URLSearchParams();
    urlParams.set("search", postUrlInput.value);
    if (selectedFields.length > 0) {
      selectedFields.forEach(field => urlParams.append("fields", field));
    }
    const shareableUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
    shareableUrlInput.value = shareableUrl;
    shareLeadsModal.show();
  });

  form.addEventListener("submit", async (ev) => {
    ev.preventDefault();
    const downloadCSVBtn = document.getElementById("download-csv");
    downloadCSVBtn.disabled = true;
    shareLeadsBtn.disabled = true;
    viewLeadsBtn.disabled = true;
    viewLeadsBtn.innerHTML = "Loading...";
    loaderTable.classList.remove("d-none");
    resultsWrapper.classList.add("d-none");

    try {
      const data = new URLSearchParams();

      for (const pair of new FormData(form)) {
        data.append(pair[0], pair[1]);
      }

      const leadsData = await fetch(`/data`, {
        method: "post",
        body: data,
      });
      
      const leadsDataJSON = await leadsData.json();

      if (!leadsData.ok) {
        throw new Error(leadsDataJSON.error || "Server error occurred");
      }

      if (leadsDataJSON?.error) {
        alert(leadsDataJSON.error);
        shareLeadsBtn.disabled = true;
      } else if (leadsDataJSON?.data) {
        const exportFileName =
          slugify(String(leadsDataJSON?.pageSlug || leadsDataJSON?.formId)) || "pymnts-leads";
        
        resultsWrapper.classList.remove("d-none");
        const table = new Tabulator("#results", {
          data: leadsDataJSON.data,
          autoColumns: true,
          pagination: "local",
          paginationSize: 10,
          paginationCounter: "rows",
        });

        // TODO: This can be cleaned up.

        const oldDownloadBttn = document.getElementById("download-csv");
        const newDownloadBttn = oldDownloadBttn.cloneNode(true);
        oldDownloadBttn.parentNode.replaceChild(
          newDownloadBttn,
          oldDownloadBttn
        );

        newDownloadBttn.disabled = false;
        shareLeadsBtn.disabled = false;

        newDownloadBttn.addEventListener("click", () => {
          table.download("csv", `${exportFileName}.csv`);
        });
      } else {
        throw new Error("No data received from server");
      }
    } catch (err) {
      console.error("Error details:", err);
      alert(err.message || "Unable to process your request at this time, sorry!");
      shareLeadsBtn.disabled = true;
    } finally {
      loaderTable.classList.add("d-none");
      viewLeadsBtn.disabled = false;
      viewLeadsBtn.innerHTML = "View leads";
    }
  });

  // Check for URL parameters on page load
  handleUrlParams();
});
